/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_ButtonInputs */

const en_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const fr_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const it_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const ru_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const es_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const zh_cn2_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const ja_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const hi_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const pt_pt2_explorer_info_description_button = /** @type {(inputs: Explorer_Info_Description_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Explorer_Info_Description_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_button = /** @type {((inputs?: Explorer_Info_Description_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_description_button(inputs)
	if (locale === "de") return de_explorer_info_description_button(inputs)
	if (locale === "it") return it_explorer_info_description_button(inputs)
	if (locale === "ru") return ru_explorer_info_description_button(inputs)
	if (locale === "es") return es_explorer_info_description_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_description_button(inputs)
	if (locale === "ja") return ja_explorer_info_description_button(inputs)
	if (locale === "hi") return hi_explorer_info_description_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_description_button(inputs)
	return en_explorer_info_description_button(inputs)
});